import {
  BEER_SOURCE_PROVENANCE_TYPES,
  INGESTION_PIPE_SOURCE_TYPE,
  MONITORING_STATUSES,
  SOURCE_CATEGORIES,
  SOURCE_STRUCTURES,
} from '../callableBeerConstants';

export const BREWERY_SOURCE_FILTER_ALL = 'all';

export function normalizeBeerSourceType(sourceDoc) {
  const value = sourceDoc?.sourceType;
  if (typeof value === 'string' && value.trim()) {
    return value.trim();
  }
  return null;
}

/** Registry scrape rows: explicit ingestion_pipe, or missing sourceType (legacy). */
export function isIngestionPipeSource(sourceDoc) {
  const normalized = normalizeBeerSourceType(sourceDoc);
  return normalized === null || normalized === INGESTION_PIPE_SOURCE_TYPE;
}

export function filterBreweryBeerSources(
  sources,
  {
    sourceStructureFilter = BREWERY_SOURCE_FILTER_ALL,
    sourceCategoryFilter = BREWERY_SOURCE_FILTER_ALL,
    monitoringStatusFilter = BREWERY_SOURCE_FILTER_ALL,
  } = {},
) {
  return sources.filter((sourceDoc) => {
    const matchesStatus =
      monitoringStatusFilter === BREWERY_SOURCE_FILTER_ALL ||
      sourceDoc.monitoringStatus === monitoringStatusFilter;
    const matchesCategory =
      sourceCategoryFilter === BREWERY_SOURCE_FILTER_ALL ||
      sourceDoc.sourceCategory === sourceCategoryFilter;
    const matchesStructure =
      sourceStructureFilter === BREWERY_SOURCE_FILTER_ALL ||
      sourceDoc.sourceStructure === sourceStructureFilter;
    const matchesIngestionPipe = isIngestionPipeSource(sourceDoc);

    return matchesStatus && matchesCategory && matchesStructure && matchesIngestionPipe;
  });
}

export function sortBreweryBeerSourcesByUrl(sources) {
  return [...sources].sort((left, right) => (left.url || '').localeCompare(right.url || ''));
}

export {
  BEER_SOURCE_PROVENANCE_TYPES,
  INGESTION_PIPE_SOURCE_TYPE,
  MONITORING_STATUSES,
  SOURCE_CATEGORIES,
  SOURCE_STRUCTURES,
};
